import DocumentCreationButton from 'Components/DocumentCreationButton';
import * as React from 'react';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import Form from './Form';
import NotesHistory from './HistoryRowData';
import { filterByDocumentType } from 'Utility/documentHandling';
import type { TRelevantDocumentType } from '../utils';

const Notes = ({ documents }: IOwnProps): React.JSX.Element => {
  const notesDocs = filterByDocumentType(documents, 'notes');
  return (
    <FormEditingHandler name="notes" documents={notesDocs}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name={'notes'}
            headerId={'notes.title'}
            editing={editing}
            infoText={!editing ? 'notes.infoText' : undefined}
            editButtons={
              <DocumentCreationButton
                name="notes"
                text={'general.new'}
                onClick={(e: React.MouseEvent): void => {
                  startEdit({}, 'notes')(e);
                }}
              />
            }
          />
          {editing ? <Form documents={documents} formData={formData} editing={editing} /> : null}
          {!editing && !view?.viewing ? <NotesHistory documents={documents} startEdit={startEdit} /> : null}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TRelevantDocumentType>>;
}

export default Notes;
